<template>
  <div>
    <h6 class="heading-small text-muted mb-3">ข้อมูลบัญชีธนาคาร</h6>
        <div class="row" v-for="(acc, index) in account" :key="index">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>{{ (account.length > 1 ? ` ธนาคาร ${index+1}` : ' ธนาคาร')}}</label>
                    <v-select 
                        :class="[ { 'is-invalid bd-danger': submit && $v.account.$each[index].account_bank.$error } , 'w-100' ]"
                        label="name"
                        :options="bank"
                        :key="acc.account_bank"
                        v-model="acc.account_bank"
                        :reduce="formatBank => formatBank.code"
                    ></v-select>
                    
                    <label
                        v-if="submit && !$v.account.$each[index].account_bank.required"
                        class="invalid-feedback d-block"
                    >กรุณาเลือกธนาคาร</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>{{ (account.length > 1 ? ` ชื่อบัญชีธนาคาร ${index+1}` : ' ชื่อบัญชีธนาคาร')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': submit && $v.account.$each[index].account_name.$error }"
                        placeholder="ชื่อบัญชีธนาคาร"
                        v-model="acc.account_name"
                    />
                    
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.account.$each[index].account_name.minLength"
                    >กรุณากรอก"ชื่อบัญชีธนาคาร"อย่างน้อย {{$v.account.$each[index].account_name.$params.minLength.min}} ตัวอักษร</label>
                    <label
                        v-if="submit && !$v.account.$each[index].account_name.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อบัญชีธนาคาร</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>{{ (account.length > 1 ? ` เลขที่บัญชี ${index+1}` : ' เลขที่บัญชี')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': submit && $v.account.$each[index].account_id.$error }"
                        placeholder="เลขที่บัญชี"
                        v-model="acc.account_id"
                    />
                    
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.account.$each[index].account_id.minLength"
                    >กรุณากรอก"เลขที่บัญชี"อย่างน้อย {{$v.account.$each[index].account_id.$params.minLength.min}} ตัวเลข</label>
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.account.$each[index].account_id.maxLength"
                    >กรุณากรอก"เลขที่บัญชี"ไม่เกิน {{$v.account.$each[index].account_id.$params.maxLength.max}} ตัวเลข</label>
                    <label
                        v-if="submit && !$v.account.$each[index].account_id.required"
                        class="invalid-feedback"
                    >กรุณากรอกเลขที่บัญชี</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>{{ (account.length > 1 ? ` สาขาธนาคาร ${index+1}` : ' สาขาธนาคาร')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': submit && $v.account.$each[index].account_branch.$error }"
                        placeholder="สาขาธนาคาร"
                        v-model="acc.account_branch"
                    />
                    
                    <label
                        v-if="submit && !$v.account.$each[index].account_branch.required"
                        class="invalid-feedback"
                    >กรุณากรอกสาขาธนาคาร</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                <label>{{ (account.length > 1 ? ` รหัสสาขา ${index+1}` : ' รหัสสาขา')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': submit && $v.account.$each[index].branch_code.$error }"
                        placeholder="รหัสสาขา"
                        v-model="acc.branch_code"
                    />
                    
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.account.$each[index].branch_code.minLength"
                    >กรุณากรอก"รหัสสาขา"อย่างน้อย {{$v.account.$each[index].branch_code.$params.minLength.min}} ตัวเลข</label>
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.account.$each[index].branch_code.maxLength"
                    >กรุณากรอก"รหัสสาขา"ไม่เกิน {{$v.account.$each[index].branch_code.$params.maxLength.max}} ตัวเลข</label>
                    <label
                        v-if="submit && !$v.account.$each[index].branch_code.required"
                        class="invalid-feedback"
                    >กรุณากรอกรหัสสาขา</label>
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-3">ข้อมูลรูปภาพ</h6>
        <div class="row">
            <div class="col-lg-6" v-for="(image,index) in images" :key="index">
                <div class="form-group">
                    <label>
                        {{image.lable}}
                    </label>
                    <b-form-file 
                        :state="validateImages(index)"
                        accept=".jpg, .png"
                        placeholder="เลือกรูปภาพ"
                        @change="uploadImage(index,$event)"
                        v-model="image.file"
                    ></b-form-file>
                    <div class="text-center pt-2" v-if="image.preview">
                        <img class="image-hover py-2" :src="image.preview" alt="image_account" width="250" height="200" @click="$emit('showModalImages',image.preview, image.name)">
                    </div>
                </div>
            </div>
        </div> 
    <hr class="my-4" />
  </div>
</template>

<script>
import Compressor from 'compressorjs'
import formatBank from "@/plugins/formatBank.js"
import {
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
    name:"FormAccount",
    props: {
        submit: Boolean,
        account: Array,
        images: Array,
        
    },
    data(){
      return{
        bank: formatBank,
      }
    },
    validations(){
      return this.rule
    },
    methods:{
        validateImages( index ){
            let res = null
            if( this.submit && this.$v.images.$each && this.$v.images.$each[index].file.$error ){
                res = false
            }else if( this.$v.images[index] && this.$v.images[index].$error ){
                res = false
            }
            else{
                res = null
            }
            return res
        },
        uploadImage(index,e) {
            if (e.target.files.length < 1) return false;
            const image = e.target.files[0]
            let SELF = this
            new Compressor(image, {
              quality: 0.6,
              maxHeight: 1024,
              maxHeight: 1024,
                success(result) {
                  const reader = new FileReader();
                  reader.readAsDataURL(result)
                  reader.onload = e => {
                    SELF.$set(SELF.images[index], 'preview' , e.target.result)
                  }
                }
            })
        },
    },
    computed:{
      rule(){
        let res = {
            account:  {
                $each: {
                    account_id: {
                        required, 
                        minLength: minLength(10), 
                        maxLength: maxLength(15)
                    },
                    account_name: { 
                        required, 
                        minLength: minLength(3) 
                    },
                    account_branch: {
                        required,
                    },
                    account_bank: {
                        required,
                    },
                    branch_code: {
                        required,
                        minLength: minLength(3), 
                        maxLength: maxLength(4)
                    }
                }
          },
          images: {
            $each: {
              file: { required }
            }
          }
        }
        return res
      },
    }
}
</script>